module.exports = __webpack_public_path__ + "static/img/d7104a3e-6032-49a5-8da9-aeb3313b044b.d25d99c7.png";